var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-reg-form"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('section', {
    staticClass: "col-md-7 pr-lg-6"
  }, [_c('div', {
    staticClass: "select-field form-group font"
  }, [_c('label', {
    attrs: {
      "for": "platform"
    }
  }, [_vm._v(" Platform on which you are using My Whoosh ")]), _c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "label": "label",
      "options": [{
        label: 'iOS',
        value: 'iOS'
      }, {
        label: 'Android',
        value: 'Android'
      }],
      "reduce": function (e) {
        return e.value;
      },
      "clearable": false
    },
    model: {
      value: _vm.platform,
      callback: function ($$v) {
        _vm.platform = $$v;
      },
      expression: "platform"
    }
  }), _vm.getError('platform') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(" Platform is required ")]) : _vm._e(), _c('small', {
    staticClass: "text-help-info pointer",
    on: {
      "click": _vm.openPopoverOs
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._v(" Click here for more info ")])], 1), _c('div', {
    staticClass: "input-field form-group font"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.smartTrainerDeviceModelName,
      expression: "smartTrainerDeviceModelName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.smartTrainerDeviceModelName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.smartTrainerDeviceModelName = $event.target.value;
      }
    }
  }), _c('label', {
    class: _vm.smartTrainerDeviceModelName ? 'top-label' : ''
  }, [_vm._v("Smart Trainer Device – Model Name")]), _vm.getError('smartTrainerDeviceModelName') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("required")]) : _vm._e(), _c('small', {
    staticClass: "text-help-info"
  }, [_vm._v(" Only direct drive smart trainers are allowed ")])]), _c('div', {
    staticClass: "input-field form-group font"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.smartTrainerDeviceSerialNumber,
      expression: "smartTrainerDeviceSerialNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.smartTrainerDeviceSerialNumber
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.smartTrainerDeviceSerialNumber = $event.target.value;
      }
    }
  }), _c('label', {
    class: _vm.smartTrainerDeviceSerialNumber ? 'top-label' : ''
  }, [_vm._v(" Smart trainer device – Serial number ")]), _vm.getError('smartTrainerDeviceSerialNumber') ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("required")]) : _vm._e()])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }